'use strict';

exports.__esModule = true;

var _reactRouter = require('react-router');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _reactRouter.matchPath;
  }
});


//////////////////
// WEBPACK FOOTER
// ./~/react-router-dom/matchPath.js
// module id = 882
// module chunks = 0